import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoaderService } from '../services/loader.service';
import { TokenService } from './../services/token.service';
import { environment } from '../../environments/environment';
import { CommonserviceService } from '../services/commonservice.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class CustomeInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private tokenService: TokenService,
    private injector: Injector, // Use Injector to break circular dependency
    private snackBar: MatSnackBar
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const excludedUrls = [
      `https://api64.ipify.org?format=json`,
      `${environment.apiUrl}/for_admin_login`,
      `${environment.apiUrl}/details/checkAadhaar/`,
      `${environment.apiUrl}/details/checkPan/`,
      `${environment.apiUrl}/details/self/agent/create/username`,
      `${environment.vcompanyAuthSelfAgentUrl}/self/agent/sendOtp`,
      `${environment.vcompanyAuthSelfAgentUrl}/self/agent/resendOtp`,
      `${environment.vcompanyAuthSelfAgentUrl}/self/agent/verifyOtp`,
      `${environment.vcompanyAuthSelfAgentUrl}/login`,
      `${environment.vcompanyAuthSelfAgentUrl}/validate/loginOtp`,
      `${environment.vcompanyAuthSelfAgentUrl}/forgotPassword`,
      `${environment.vcompanyAuthSelfAgentUrl}/validate/forgetPasswordOtp`,
      `${environment.vcompanyAuthSelfAgentUrl}/resetUserPassword`,
      `${environment.vAdminauthUrl}/vadminauth/customer/checkSubmission`,
      `${environment.apiUrl2}/idverification/verify/customer/doc`,
      `${environment.apiUrl2}/idverification/digi-verify/customer/doc`,
      `${environment.apiUrl2}/idverification/digi/aadhar/customer/download`,
      `${environment.apiUrl2}/upload/customer/file`,
      `${environment.apiUrl2}/peocit/self/register/customer`,
      `${environment.peocitVtransactionUrl}/extarnal/getcustomer`,
      `${environment.vAdminauthUrl}/vadminauth/agent/webKYC`,
      `${environment.vAdminauthUrl}/vadminauth/feesPayment/get`,
      `${environment.vAdminauthUrl}/vadminauth/customer/payment`,
      `${environment.vAdminauthUrl}/vtransaction/peocit/getinvited/customer`,
      `${environment.apiUrl2}/idverification/verify/customer/aadhar/submitotp`,
      `${environment.apiUrl2}/payment/customer/get/orderid`,
      `${environment.apiUrl2}/payment/customer/order/place`,
      `${environment.apiUrl2}/digiPigmy/get/providerCode`,
      `${environment.vAdminauthUrl}/vdashboard/vagent/profile/get/locationbyPincode`,
      `${environment.vAdminauthUrl}/vdashboard/vagent/profile/get/locationbyInput`,
      `${environment.apiUrl}/idverification/digi/aadhar/download`,
      `${environment.vAdminauthUrl}/vitadmin/get/versioncode`,
      `${environment.vAdminauthUrl}/vitadmin/get/vkycagent/name`,
      `${environment.vAdminauthUrl}/vitadmin/pg/getlog`,
      `${environment.vAdminauthUrl}/vdashboard/vadmin/agent/get/address/byPeocit`,
      `${environment.apiUrl2}/idverification/save-customer-sub-district`
    ];
    // const loaderExcludedUrls = [
    //   `${environment.vAdminauthUrl}/vdashboard/vadmin/agent/get/address/byPeocit`
    // ];

    // const skipLoader = loaderExcludedUrls.some(url =>
    //   request.url.includes(url)
    // );

    // If request URL is excluded, skip token & auth logic
    // if (excludedUrls.some(url => request.url.includes(url))) {
    //   this.loaderService.show();
    //   return next.handle(request).pipe(
    //     finalize(() => this.loaderService.hide())
    //   );
    // }



    if (excludedUrls.some(url => request.url.includes(url))) {

      const skipLoader = request.url.includes(
        `${environment.vAdminauthUrl}/vdashboard/vadmin/agent/get/address/byPeocit`
      );

      if (!skipLoader) {
        this.loaderService.show();
      }

      return next.handle(request).pipe(
        finalize(() => {
          if (!skipLoader) {
            this.loaderService.hide();
          }
        })
      );
    }


    // Get token from sessionStorage
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = sessionStorage.getItem('loginToken');
    }

    if (!token) {

      sessionStorage.clear();
      this.router.navigate(['/login']);
      return EMPTY;
    }

    const isExpired = this.tokenService.isTokenExpired(token);
    if (isExpired) {

      sessionStorage.clear();
      this.router.navigate(['/login']);
      return EMPTY;
    }

    // Clone request to add Authorization header
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    this.loaderService.show();

    return next.handle(request).pipe(
      finalize(() => this.loaderService.hide()),
      catchError((error: HttpErrorResponse) => {
        const globalService = this.injector.get(CommonserviceService); // Lazy inject service here

        if (error.status === 401) {
          console.log("Log out 3");
          sessionStorage.clear();
          this.router.navigate(['/login']);
        } else if (error.status === 0) {
          globalService.showError('Unable to reach server');
        }

        return throwError(() => error);
      })
    );
  }
}
